import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
import { siteConfig, navigationLinks } from '../../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#1E3A8A] border-t-4 border-[#E31837]">
      <div className="container-custom py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-4 mb-8">
              <img
                src={siteConfig.logo}
                alt={siteConfig.name}
                className="h-16 w-16 object-contain"
              />
              <div>
                <span className="text-white font-bold text-xl font-['Merriweather']">{siteConfig.name}</span>
                <span className="block text-[#E31837] text-sm font-semibold tracking-wider uppercase">
                  {siteConfig.tagline}
                </span>
              </div>
            </div>
            <p className="text-gray-300 text-base leading-relaxed">
              Transforming lives through evidence-based coaching and the 7-Domain Wellness Wheel approach.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6 font-['Merriweather']">Quick Links</h4>
            <nav className="flex flex-col gap-4">
              {navigationLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-gray-300 hover:text-[#E31837] transition-colors text-base"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Program */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6 font-['Merriweather']">Program</h4>
            <nav className="flex flex-col gap-4">
              <Link to="/program" className="text-gray-300 hover:text-[#E31837] transition-colors text-base">
                12-Week Program
              </Link>
              <Link to="/program#domains" className="text-gray-300 hover:text-[#E31837] transition-colors text-base">
                7 Wellness Domains
              </Link>
              <Link to="/ai-coach" className="text-gray-300 hover:text-[#E31837] transition-colors text-base">
                AI Wellness Coach
              </Link>
              <a href="#" className="text-gray-300 hover:text-[#E31837] transition-colors text-base">
                Matrix Engine
              </a>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6 font-['Merriweather']">Contact</h4>
            <div className="flex flex-col gap-5">
              <a
                href={`tel:${siteConfig.phone.replace(/[^0-9]/g, '')}`}
                className="flex items-center gap-4 text-gray-300 hover:text-[#E31837] transition-colors text-base"
              >
                <Phone className="w-5 h-5 text-[#E31837]" />
                <span>{siteConfig.phone}</span>
              </a>
              <a
                href={`mailto:${siteConfig.email}`}
                className="flex items-center gap-4 text-gray-300 hover:text-[#E31837] transition-colors text-base"
              >
                <Mail className="w-5 h-5 text-[#E31837]" />
                <span>{siteConfig.email}</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-16 pt-10 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-gray-400 text-base">
            © {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
          <div className="flex gap-8">
            <a href="#" className="text-gray-400 hover:text-[#E31837] text-base transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-[#E31837] text-base transition-colors">
              Terms of Service
            </a>
            <a href="#" className="text-gray-400 hover:text-[#E31837] text-base transition-colors">
              Disclaimer
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
